var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Type, Transform } from 'class-transformer';
import { IsIn, IsArray, IsString, IsDateString, IsUUID, IsNotEmpty, ValidateNested, IsOptional, } from 'class-validator';
import { injectable } from 'inversify';
import { HttpService } from '@vk-hr-tek/core/http';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { UnmarshallerService } from '@vk-hr-tek/core/unmarshaller';
import { QueryService } from '@vk-hr-tek/core/query';
export class UpdateFilterPresetParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateFilterPresetParams.prototype, "filter_preset_id", void 0);
export class GetFilterPresetParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetFilterPresetParams.prototype, "filter_preset_id", void 0);
export class ListFilterPresetsQuery {
}
__decorate([
    IsIn([
        'events',
        'schedule_events',
        'absence_events',
        'employees',
        'company_policies',
        'candidate_events',
        'goal_management',
        'business_trips',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ListFilterPresetsQuery.prototype, "list_code", void 0);
export class FileRequestDownloadQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FileRequestDownloadQuery.prototype, "download_id", void 0);
export class GetFileRequestStateQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetFileRequestStateQuery.prototype, "download_id", void 0);
export class FilterPreset {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterPreset.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterPreset.prototype, "name", void 0);
__decorate([
    IsIn(['purple', 'orange', 'red', 'green', 'blue']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterPreset.prototype, "color", void 0);
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], FilterPreset.prototype, "filters", void 0);
export class ListFilterPresetsResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => FilterPreset),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ListFilterPresetsResponse.prototype, "presets", void 0);
export class FileDownload {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FileDownload.prototype, "download_id", void 0);
__decorate([
    IsIn(['in_progress', 'done', 'expired', 'error']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FileDownload.prototype, "status", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FileDownload.prototype, "error_message", void 0);
export class GetFileRequestStateResponse {
}
__decorate([
    ValidateNested(),
    Type(() => FileDownload),
    IsNotEmpty(),
    __metadata("design:type", FileDownload)
], GetFileRequestStateResponse.prototype, "download", void 0);
export class UploadFileResponse {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UploadFileResponse.prototype, "temporary_file_id", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UploadFileResponse.prototype, "expired_at", void 0);
export class RecognizedQrCodeMultipleAttribute {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizedQrCodeMultipleAttribute.prototype, "id", void 0);
__decorate([
    IsIn(['multi_attribute']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizedQrCodeMultipleAttribute.prototype, "type", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], RecognizedQrCodeMultipleAttribute.prototype, "values", void 0);
export class RecognizedQrCodeAttribute {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizedQrCodeAttribute.prototype, "id", void 0);
__decorate([
    IsIn(['attribute']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizedQrCodeAttribute.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizedQrCodeAttribute.prototype, "value", void 0);
export class RecognizeQrCodeResponse {
}
__decorate([
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], RecognizeQrCodeResponse.prototype, "attributes", void 0);
export class RecognizedAttribute {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizedAttribute.prototype, "id", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizedAttribute.prototype, "value", void 0);
export class RecognizeDocumentResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => RecognizedAttribute),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], RecognizeDocumentResponse.prototype, "attributes", void 0);
export class FilterValuesOneOf {
}
export class CreateOrUpdateFilterPresetRequest {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateOrUpdateFilterPresetRequest.prototype, "name", void 0);
__decorate([
    IsIn(['purple', 'orange', 'red', 'green', 'blue']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateOrUpdateFilterPresetRequest.prototype, "color", void 0);
__decorate([
    ValidateNested(),
    Type(() => FilterValuesOneOf),
    IsNotEmpty(),
    __metadata("design:type", FilterValuesOneOf)
], CreateOrUpdateFilterPresetRequest.prototype, "filters", void 0);
export class DeleteFilterPresetsRequest {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], DeleteFilterPresetsRequest.prototype, "ids", void 0);
export class UploadFileRequest {
}
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    Type(() => String),
    IsNotEmpty(),
    __metadata("design:type", File)
], UploadFileRequest.prototype, "file", void 0);
export class RecognizeQrCodeRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizeQrCodeRequest.prototype, "cache_file_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizeQrCodeRequest.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizeQrCodeRequest.prototype, "node_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizeQrCodeRequest.prototype, "attribute_id", void 0);
export class RecognizeDocumentRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizeDocumentRequest.prototype, "cache_file_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizeDocumentRequest.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizeDocumentRequest.prototype, "node_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RecognizeDocumentRequest.prototype, "attribute_id", void 0);
export class ConvertImageRequest {
}
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    Type(() => String),
    IsNotEmpty(),
    __metadata("design:type", File)
], ConvertImageRequest.prototype, "image", void 0);
let ToolsService = class ToolsService {
    constructor(validator, http, unmarshaller, query) {
        this.validator = validator;
        this.http = http;
        this.unmarshaller = unmarshaller;
        this.query = query;
    }
    updateFilterPreset(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateFilterPresetParams),
                this.validator.validateOrReject(body, CreateOrUpdateFilterPresetRequest),
            ]);
            let requestPath = '/filter_preset/{filter_preset_id}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, { withSide: true });
            return result;
        });
    }
    getFilterPreset(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetFilterPresetParams),
            ]);
            let requestPath = '/filter_preset/{filter_preset_id}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, FilterPreset);
            return response;
        });
    }
    deleteFilterPresets(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, DeleteFilterPresetsRequest),
            ]);
            let requestPath = '/filter_preset/delete';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            return result;
        });
    }
    listFilterPresets(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query }) {
            yield Promise.all([
                this.validator.validateOrReject(query, ListFilterPresetsQuery),
            ]);
            let requestPath = '/filter_preset';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, ListFilterPresetsResponse);
            return response;
        });
    }
    createFilterPreset(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body, }) {
            yield Promise.all([
                this.validator.validateOrReject(body, CreateOrUpdateFilterPresetRequest),
            ]);
            let requestPath = '/filter_preset';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, FilterPreset);
            return response;
        });
    }
    fileRequestDownload(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query }) {
            yield Promise.all([
                this.validator.validateOrReject(query, FileRequestDownloadQuery),
            ]);
            let requestPath = '/file_request/download';
            const result = yield this.http.getFile(requestPath, {
                withAuth: true,
                withSide: true,
                isJson: true,
            }, query);
            return result;
        });
    }
    getFileRequestState(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetFileRequestStateQuery),
            ]);
            let requestPath = '/file_request';
            const result = yield this.http.get(requestPath, query, {});
            const response = yield this.unmarshaller.unmarshall(result, GetFileRequestStateResponse);
            return response;
        });
    }
    uploadFile(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, UploadFileRequest),
            ]);
            let requestPath = '/tools/file/upload';
            const result = yield this.http.post(requestPath, body, { isJson: false });
            const response = yield this.unmarshaller.unmarshall(result, UploadFileResponse);
            return response;
        });
    }
    recognizeQrCode(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, RecognizeQrCodeRequest),
            ]);
            let requestPath = '/tools/qr_code/recognize';
            const result = yield this.http.post(requestPath, body, {});
            const response = yield this.unmarshaller.unmarshall(result, RecognizeQrCodeResponse);
            return response;
        });
    }
    recognizeDocument(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, RecognizeDocumentRequest),
            ]);
            let requestPath = '/tools/document/recognize';
            const result = yield this.http.post(requestPath, body, {});
            const response = yield this.unmarshaller.unmarshall(result, RecognizeDocumentResponse);
            return response;
        });
    }
    convertImage(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, ConvertImageRequest),
            ]);
            let requestPath = '/tools/image/convert';
            const result = yield this.http.generateFile(requestPath, body, {
                isJson: false,
            });
            return result;
        });
    }
};
ToolsService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [ValidationService,
        HttpService,
        UnmarshallerService,
        QueryService])
], ToolsService);
export { ToolsService };
